module.exports = __webpack_public_path__ + "static/media/illustration-home-mobile.4c4edb52.png";